module.exports = __webpack_public_path__ + "img/images_video.52be57b8.svg";